














import { Vue, Prop, Component } from "vue-property-decorator";

import { getAllDocumentsDownloadUrl, getReportDownloadUrl } from "@/data/repository/FirebaseImageRepository";
import { COLOR_DARK_FILL_TEXT, COLOR_DOWNLOAD_FILE_BUTTON_ICON, COLOR_PROJECT_STEP_BUTTON_REPORT } from "@/utils/colors";
import { themed, themedFill } from "@/utils/Theme";
import { createCustomTimestampForAllDocuments } from "@/utils/Utils";
import { DownloadFileType, getFileTypeIcon } from "@/utils/FileTypeIcons";
import Report from "@/data/models/Report";

@Component
export default class DownloadFileButton extends Vue {
  @Prop() downloadRef?: string;
  @Prop() downloadAllRefs!: string[];
  @Prop({ default: false }) isListOfDocuments!: boolean;
  @Prop() title!: string;
  /**
   * What this button produces, so the icon names the file type rather than repeating the label.
   *
   * Optional: a caller that does not know (or a step whose document could be anything) gets the
   * neutral file icon instead of a wrong one.
   */
  @Prop() fileType?: DownloadFileType;
  @Prop({ default: "" }) projectNumber!: string;
  @Prop({ default: "" }) stepName!: string;
  @Prop()
  reports!: Array<Report>;

  /** The report tile's grey, as the dark palette's grey in dark mode (its label stays black). A getter so a theme switch repaints it. */
  get color() {
    return themedFill(COLOR_PROJECT_STEP_BUTTON_REPORT);
  }

  downloadUrl = "";
  downloadFilename = "";

  /** The grey file icon would vanish on the dark palette grey, so in dark mode it takes the label colour. */
  get colorIcon() {
    return themed(COLOR_DOWNLOAD_FILE_BUTTON_ICON, COLOR_DARK_FILL_TEXT);
  }

  /**
   * The file-type icon, with the whole-step download keeping the archive icon.
   *
   * "Alle Dokumente" really does produce a ZIP of several files, so that one is a type as much as a
   * bulk action.
   */
  get icon(): string {
    if (this.isListOfDocuments) {
      return getFileTypeIcon(DownloadFileType.ARCHIVE);
    }

    return getFileTypeIcon(this.fileType);
  }

  async mounted() {
    if (this.isListOfDocuments && this.downloadAllRefs) {
      const suffix = this.$t("projectStatus.documentsFilename").toString();
      const project = this.projectNumber;
      const timestamp = createCustomTimestampForAllDocuments();

      this.downloadFilename = `${project}_${timestamp}_${suffix}.zip`;
      this.downloadUrl = await getAllDocumentsDownloadUrl(this.downloadAllRefs, this.reports ?? []);
    }
    else if (this.downloadRef) {
      this.downloadUrl = await getReportDownloadUrl(this.downloadRef);
    }
  }
}
